import { withStyles } from "@material-ui/core/styles";
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import FoodBankOutlinedIcon from '@mui/icons-material/FoodBankOutlined';
import * as React from 'react';

export default function RendersIcons(props) {
    const CustomColorIconButton = withStyles({
        root: {
            color: "#000",
            margin: "0%",
            maxWidth: "56px"
        }
    })(IconButton);

    switch (props.title) {
        case "Le Pizze":
            return (
                //<CustomColorIconButton>
                    <LocalPizzaIcon />
                //</CustomColorIconButton>
            )
        case "Antipasti caldi":
            return (
                //<CustomColorIconButton>
                    <FoodBankOutlinedIcon />
                //</CustomColorIconButton>
            )
        default:
            return (
                //<Avatar>
                    <FoodBankOutlinedIcon />
                //</Avatar>
            )
    }
}